import { Body16 } from "../Text";

const Body = ({ children, style, className }) => (
  <Body16 style={style} className={className}>
    {children}
  </Body16>
);
export default Body;
